class VideoGalleryGrid extends HHBaseElement {
    loading = false
  
    constructor() {
      super()
      this.$grid = this.querySelector('.blog-articles')
      this.$backdrop = this.querySelector('.js-backdrop')
      this._handleLoadMore = this._handleLoadMore.bind(this)
    }
  
    connectedCallback() {
      this._attachListeners()
      this._setLoadMoreListners()
    }
  
    disconnectedCallback() {
      this._removeListeners()
    }
  
    get nextPageUrl() {
      return this.getAttribute('data-paginate-next')
    }
  
    set nextPageUrl(value) {
      return this.setAttribute('data-paginate-next', value)
    }
  
    get previousPageUrl() {
      return this.getAttribute('data-paginate-previous')
    }
  
    set previousPageUrl(value) {
      return this.setAttribute('data-paginate-previous', value)
    }
  
    async _fetchPage(nextUrl) {
      if (nextUrl) {
        const response = await fetch(nextUrl)
        const $page = document.createElement('div')
        $page.innerHTML = await response.text()
        const articleGrid = $page.querySelector('video-gallery-grid')
        return {
          products: $page.querySelectorAll(
            'video-gallery-grid .blog-articles > *:not([data-load-more])'
          ),
          loadMoreButton: $page.querySelector(
            'video-gallery-grid .collection-grid__load-more'
          ),
          paginateNext: articleGrid.nextPageUrl,
          paginatePrevious: articleGrid.previousPageUrl
        }
      }
  
      throw new Error('No More Page to Load')
    }
  
    _addProductsAndCards(contents = []) {
      if (this.$loadMoreContainer) {
        this.$loadMoreContainer.before(...contents)
      } else {
        this.$grid.append(...contents)
      }
    }
  
    _renderPage(page, reset = false) {
      this.nextPageUrl = page.paginateNext
      this.previousPageUrl = page.paginatePrevious
      if (reset) {
        this.$grid.innerHTML = ''
        for (const item of page.products) {
          this.$grid.append(item)
        }
      } else {
        this._addProductsAndCards(page.products)
      }
  
      if (page.filterContent) {
        this.$filtersForm.innerHTML = page.filterContent.innerHTML
        this.$filtersFormSubmitable.innerHTML = page.mobileFilterContent.innerHTML
      }
  
      if (page.loadMoreButton) {
        this.$loadMoreContainer.remove()
        this.$grid.append(page.loadMoreButton)
        this._setLoadMoreListners()
      }
    }
  
    async _handleLoadMore(event) {
      event.preventDefault()
      try {
        if (this.loading) {
          return
        }
        this._setLoading(true)
        this.$loadMore.setAttribute('disabled', true)
        const nextPage = await this._fetchPage(this.nextPageUrl)
        this._renderPage(nextPage)
      } catch (error) {
        console.error(error)
      } finally {
        this._setLoading(false)
      }
    }
  
    _setLoadMoreListners() {
      if (this.$loadMore) {
        this.$loadMore.removeEventListener('click', this._handleLoadMore)
      }
  
      this.$loadMore = this.querySelector('[data-load-more]')
      this.$loadMoreContainer = this.querySelector('.collection-grid__load-more')
  
      if (this.$loadMore) {
        this.$loadMore.addEventListener('click', this._handleLoadMore)
      }
    }

    _attachListeners() {
      this.$filtersForm?.addEventListener('change', this._handleFiltersChange)
      this.$filtersFormSubmitable?.addEventListener(
        'submit',
        this._handleFilterFormSubmit
      )
      this.addEventListener('click', this._handleClearAllClick)
      window.addEventListener('popstate', this._handleLocationPopState)
    }
  
    _removeListeners() {
      this.$filtersForm.removeEventListener('change', this._handleFiltersChange)
      this.$filtersFormSubmitable.removeEventListener(
        'submit',
        this._handleFilterFormSubmit
      )
      this.removeEventListener('click', this._handleClearAllClick)
      window.removeEventListener('popstate', this._handleLocationPopState)
    }
  
    _setLoading(loading) {
      this.loading = loading
      this._applyState()
    }
  
    _applyState() {
      this.$backdrop.classList[this.loading ? 'add' : 'remove']('visible')
      this.classList[this.loading ? 'add' : 'remove']('loading')
    }
  }
  
window.customElements.define('video-gallery-grid', VideoGalleryGrid)
  